import React from 'react'
import { LaserProfile, OpenLaserProfile } from './../LaserProfile'
import { HatchProfile, OpenHatchProfile } from './../HatchProfile'
import * as Yup from 'yup'
import {snapshot} from "valtio";
import store from "@/store";

const formView = (defaultValues, value) => {
    
    const {companySetting} = snapshot(store)
    
    const returnObject = [
        {
            name: 'sectionId',
            type: 'Hidden',
            defaultValue: defaultValues?.sectionId,
            labelClassName: 'hidden',
        },
        
        {
            name: 'center_section_to_field',
            label: 'Center Section To Field',
            placeholder: 'Angle',
            type: 'Checkbox',
            className: 'col-span-12 row-span-1 !px-[0px] !bg-transparent',
            labelClassName: 'hidden',
            defaultValue: defaultValues?.center_section_to_field !== undefined ? defaultValues.center_section_to_field : true,
            clear: false,
            reset: false,
        },
        
        {
            name: 'maintain_aspect_ratio',
            label: 'Maintain Aspect Ratio',
            type: 'Checkbox',
            className: 'col-span-12 row-span-1 !px-[0px] !bg-transparent',
            labelClassName: 'hidden',
            defaultValue: defaultValues?.maintain_aspect_ratio !== undefined ? defaultValues?.maintain_aspect_ratio : true,
            clear: false,
            reset: false,
        },
        
        {
            name: 'horizontal_ratio_percentage',
            label: 'Keystone Ratio correction',
            placeholder: 'Horizontal',
            type: 'Number',
            className: 'col-span-4 row-span-1',
            labelClassName: 'w-[300px]',
            defaultValue:
                defaultValues?.horizontal_ratio_percentage !== undefined ? defaultValues?.horizontal_ratio_percentage : '0',
            clear: false,
            reset: false,
            validation: Yup.string().required('Required'),
            validationMessage: false,
        },
        {
            name: 'vertical_ratio_percentage',
            label: 'vertical_ratio_percentage',
            placeholder: 'Vertical',
            type: 'Number',
            className: 'col-span-4 row-span-1',
            labelClassName: 'opacity-0',
            defaultValue:
                defaultValues?.vertical_ratio_percentage !== undefined ? defaultValues?.vertical_ratio_percentage : '0',
            clear: false,
            reset: false,
            validation: Yup.string().required('Required'),
            validationMessage: false,
        },
        {
            name: 'outline_laser_profile_id',
            label: 'Outline Laser Profile Name',
            type: 'Select',
            api: {
                url: '/laserprofiles/',
                optionValue: (item) => ({
                    value: item.id,
                    label: item.name,
                }),
            },
            className: 'col-span-10 row-span-1',
            defaultValue: defaultValues?.outline_laser_profile_id || null,
            validation: Yup.string().required('Laser Profile is required'),
            validationMessage: false,
        },
        {
            name: 'add_laser_profile',
            label: '+',
            labelClassName: 'opacity-0',
            className: '',
            type: 'PopUp',
            module: LaserProfile,
            view: OpenLaserProfile,
            title: 'Manage Laser Profiles',
            innerClassName: '',
            parent: 'outline_laser_profile_id',
        },
        {
            name: 'hatch_profile_ids',
            label: 'Hatch Profile Name',
            type: 'Select',
            api: {
                url: '/hatchprofiles/',
                optionValue: (item) => ({
                    value: item.id,
                    label: item.name,
                }),
            },
            features: {
                isMulti: true,
            },
            className: 'col-span-10 row-span-1',
            defaultValue: defaultValues?.hatch_profile_ids || null,
            validation: Yup.array().required('Hatch Profile is required'),
            validationMessage: false,
            //defaultValue: ["6fb25645-d84c-42da-8197-f141f256232f"]
        },
        {
            name: 'add_hatch_laser_profile',
            label: '+',
            labelClassName: 'opacity-0',
            className: '',
            type: 'PopUp',
            module: HatchProfile,
            view: OpenHatchProfile,
            title: 'Manage Hatch Profiles',
            parent: 'hatch_profile_ids',
        },
        /*{
              name: "add_hatch_laser_profile",
              type: "Button",
              buttonType: "alt",
              label: "+",
              labelClassName: "opacity-0",
              className: "col-span-2 w-[37px] font-icon-solid",
          },*/
        {
            name: 'marking_order',
            label: 'Marking Order',
            type: 'Select',
            list: [
                { label: 'Hatch Only', value: 'hatch_only' },
                { label: 'Outline Only', value: 'outline_only' },
                { label: 'Hatch Before Outline', value: 'hatch_before_outline' },
                { label: 'Outline Before Hatch', value: 'outline_before_hatch' },
            ],
            className: 'col-span-12 row-span-1',
            defaultValue: defaultValues?.marking_order || 'hatch_only',
            validation: Yup.string().required('Marking order is required'),
            validationMessage: false,
        },
        {
            name: 'preview_mark_type',
            label: 'Preview Mark Type',
            type: 'Select',
            list: [
                { label: 'Outline', value: 'outline' },
                { label: 'Tight Boundary', value: 'tight_boundary' },
                { label: 'Bounding Box', value: 'bounding_box' },
                { label: 'Off', value: 'off' },
            ],
            className: 'col-span-12 row-span-1',
            defaultValue: defaultValues?.preview_mark_type || 'tight_boundary',
            validation: Yup.string().required('Mark type is required'),
            validationMessage: false,
            //menuPortalTarget: ".PopUpForm_shape_profile",
        },
        {
            name: 'preview_mark_speed',
            label: 'Preview Mark Speed',
            placeholder: 'Speed',
            type: 'Number',
            className: 'col-span-4 row-span-1',
            labelClassName: 'w-[300px]',
            defaultValue: defaultValues?.preview_mark_speed || 5000,
            validation: Yup.string().required('Preview mark speed is required'),
            validationMessage: false,
        },
    ]
    
    
    if (!companySetting?.machine) {
        returnObject.forEach((item, index) => {
            if (item.name === 'hatch_profile_ids') {
                returnObject[index].defaultValue = ["8491afa7-7cf0-477a-b0da-e5a9b9c58151"]
            }
            if (item.name === 'outline_laser_profile_id') {
                returnObject[index].defaultValue = "1afd5289-ab24-49b8-a12b-f4b5371150fd"
            }
        })
    
    }
    
    return returnObject
}

export default formView
